class AtheneumSelfDirectedLookup {
    constructor(form, $formElement, $modal, callback, options) {

        if(!form){
            let title = window.AtheneumInstance.Translation.getOrGetThemeKey('sdlErrorTitle', 'Error');
            let message = window.AtheneumInstance.Translation.getOrGetThemeKey('sdlErrorNoForm', 'Form not provided!');
            window.AtheneumInstance.UI.Notifications.showCustomNotification("error", message, title);
            return;
        }
        
        if(!form.enableSelfDirectedLookup){
            let title = window.AtheneumInstance.Translation.getOrGetThemeKey('sdlErrorTitle', 'Error');
            let message = window.AtheneumInstance.Translation.getOrGetThemeKey('sdlErrorSDLNotEnabled', 'Form is not SDL enabled!');
            window.AtheneumInstance.UI.Notifications.showCustomNotification("error", message, title);
            return;
        }
           
        this.form = form;
		this.fields = this.form.fields;
		this.$formElement = $formElement;
        this.$modal = $modal;
		if(this.$modal)
			this.$header = $modal.find('.modal-title');
		else
			this.$header = $('#salestoolkit-form-name');

        this.Atheneum = window.AtheneumInstance;
       
		this.contextPath = this.Atheneum.API.BASE_URL;
		this.contextPath = this.contextPath.slice(0, this.contextPath.indexOf('/restful'))
        this.defaultOptions = {
            trackTiming: true,
            showCustomNotifications : true,
            iframe: false
        }

        this.callback = callback;
        
        this.options = { ...this.defaultOptions, ...options};
        this.uid = this.uuidv4();
        if(this.$formElement)
            this.$formElement.attr('data-self-directed-lookup-id', this.uid);
        
        this.nationalIdFields = [];
		this.sdlOptionChosen = "";
		this.hasTriedSdlAlternative = false;
		this.userDetailsFields = [];
		this.regularFormFields = [];

		this.sdlIndex = -1;
		this.sdlMatches = [];
		this.sdlFields = [];
		this.currentSdlValues = {};

        window[this.uid] = this;
    }

    uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

	isEmptyString(str) {
		return (!str || /^\s*$/.test(str));
	}
	  
	isArray(obj) {
		return (typeof obj === 'object' && obj != null && obj.constructor === Array);
	}
	
	isFunction(obj) {
		return (typeof obj === "function");
	}

    setupSDL() {
        /*** SELF DIRECTED LOOKUP CODE ***/
  		this.nationalIdFields = this.form.fields.filter(function(field) {
            return field.properties.nationalIdField === true || field.properties.nationalIdField === "true";
        });
        this.userDetailsFields = this.form.fields.filter(function(field) {
            return field.properties.userDetailsField === true || field.properties.userDetailsField === "true";
        });
        
		let fieldsWithVirtualKeyboard = this.form.fields.filter(function(field) {
            return field.properties.useVirtualKeyboard === true || field.properties.useVirtualKeyboard === "true";
        });

        let hasNationalIdOption = false;
        if (this.nationalIdFields!=undefined && this.nationalIdFields !=null && this.nationalIdFields.length>0){
            hasNationalIdOption = true;				
        }
        
        let hasUserDetailsOption = false;
        if (this.nationalIdFields!=undefined && this.nationalIdFields !=null && this.nationalIdFields.length>0){
            hasUserDetailsOption = true;				
        }
        
        if (hasNationalIdOption && hasUserDetailsOption){
            this.showInitialSDLPopup();
        } else if (hasNationalIdOption){
            this.showNationalIdForm();
        } else if (hasUserDetailsOption){
            this.showUserDetailsForm();
        } else {
            $('.c_form').removeClass('hidden');
        }
    }

    validateSdlFields (fieldsToCheck) {
        for (const field of fieldsToCheck) {
            const $field = this.$formElement.find(
				'input[name="' + field.name + '"]'
				+ ', select[name="' + field.name + '"]'
				+ ', textarea[name="' + field.name + '"]'
			);
            const value = $field.val();
            
            if (value === null || value === undefined || value.trim() === "") {
                return false;
            }
        }
        
        return true;
    }

	performSelfDirectedLookup(){
			
		let initialSdlFields;
		
		if (this.sdlOptionChosen == 'nationalId'){
			initialSdlFields = this.nationalIdFields;
		} else if (this.sdlOptionChosen == 'userDetails'){
			initialSdlFields = this.userDetailsFields;
		} else {
			return;
		}
		
		if (!this.validateSdlFields(initialSdlFields)){
			let popupButtons = [{
				text: this.Atheneum.Translation.get('ok', 'OK'),
				action: 'close'
			}];
			this.showSdlPopup(this.Atheneum.Translation.get('invalidSDLFieldsTitle', 'Please fill the form'), this.Atheneum.Translation.get('invalidSDLFieldsMessage', 'Please fill all the fields to perform the lookup'), popupButtons, false);
			return;

		}
		
		let filterMap = {};
		for (let i = 0; i < initialSdlFields.length; i++) {
			let fieldName = initialSdlFields[i].name;
			let field = $('input[name="'+ fieldName +'"]');
			if (field.length <= 0) {
				continue;
			} 
			if (!this.isEmptyString(field[0].value)){
				filterMap[fieldName]=field[0].value;
				this.currentSdlValues[fieldName] = field[0].value;
			}
		}	
		
		if (!filterMap || Object.keys(filterMap).length === 0) {
			return;
		}
		let matches = [];
		
		//This is to look on veeva
		const fieldsArray = this.fields.map(item => item.name);
		let filterParam = encodeURIComponent(JSON.stringify(filterMap));
		
		let sdlThis = this;
		$.getJSON(this.contextPath + '/download-portal/veeva/search?apikey='+this.Atheneum.User.apikey+'&fields='+fieldsArray+"&filter="+filterParam+"&pa=d7eabd338ba458a4018bd311a2ca6f52", function(data) {
			if (typeof data === 'object' && data.hasOwnProperty('matches') && data.matches.length >= 1) {
				matches = data.matches;	
				
				if (matches.length==1) {
					sdlThis.fillFormWithContactMatch(matches[0]);
					sdlThis.showRegularForm(true);
				} else {
					sdlThis.startSdlQuestionnaire(matches);
				}
			} else {
				sdlThis.showNoMatchesPopup();
			}
		});
	}  

   
	showNoMatchesPopup(){
	
		let sdlThis = this;
		let popupButtons = [];
		if (this.hasTriedSdlAlternative) {
			popupButtons = [{
				text: this.Atheneum.Translation.get('tryAgain', 'Try again'),
				action: 'close'
			},
			{
				text: this.Atheneum.Translation.get('goToForm', 'Go to form'),
				action: function(){
					sdlThis.showRegularForm(false);
				}
			}];
		} else {
			popupButtons = [{
				text: this.Atheneum.Translation.get('tryAgain', 'Try again'),
				action: 'close'
			},
			{
				text: this.Atheneum.Translation.get('switchToLUD', 'Switch to Look Up by User Details'),
				action: function(){
					sdlThis.switchSdlForm();
				} 
				
			},
			{
				text: this.Atheneum.Translation.get('goToForm', 'Go to form'),
				action: function(){
					sdlThis.showRegularForm(false);
				}
				
			}];
		}
			
		this.showSdlPopup(this.Atheneum.Translation.get('noMatchesFoundTitle', 'No Matches Found'), this.Atheneum.Translation.get('noMatchesFoundMessage', 'There are no matches in the contacts with those details'), popupButtons, false);
	}
		
	showMoreThanOneMatchesPopup(){
		let sdlThis = this;
		let popupButtons = [{
				text: this.Atheneum.Translation.get('tryAgain', 'Try again'),
				action: 'close'
			},
			{
				text: this.Atheneum.Translation.get('goToForm','Go to form'),
				action: function(){
					sdlThis.showRegularForm(false);
				}
				
			}];
		this.showSdlPopup(this.Atheneum.Translation.get('moreThanOneMatchTitle','More than one match found'), this.Atheneum.Translation.get('moreThanOneMatchMessage','There are more than one matches in the contacts with those details but we do not have any extra questions to refine the search'), popupButtons, false);
	}


		// //SDLRelated
	showInitialSDLPopup(){
		//TODO: clean form
		let sdlThis = this;
		clearForm(sdlThis.$formElement);
		let popupButtons = [{
				text: this.Atheneum.Translation.get('lookupByNID','Look Up by National ID'),
				action: function(){
					sdlThis.showNationalIdForm();
				}
			},
			{
				text: this.Atheneum.Translation.get('lookupByPostCode', 'Look up by name and postcode'),
				action: function(){
					sdlThis.showUserDetailsForm();
				}
			}];
		this.showSdlPopup(this.Atheneum.Translation.get('lookupOptions', 'Look up options'), this.Atheneum.Translation.get('pleaseSelectFormForLookup', 'Please select the form you would like to use to do the look up'), popupButtons, false);
	}
		
	showSdlPopup(title, message, customButtons) {
		this.$modal.modal('hide');
		$('#sdlPopup').remove();
		let popup = $('<div class="modal fade in" style="display:block" id="sdlPopup"></div>');
		let outer = $('<div class="modal-dialog"></div>');
		let inner = $('<div class="modal-content"></div>');
		outer.append(inner);
		popup.append(outer);
		let header = $('<div class="portlet-title modal-header"></div>');
		inner.append(header);
		let content = $('<div class="modal-body portlet-title"></div>');
		inner.append(content);
		
		if (typeof title == 'string' && !this.isEmptyString(title)) {
			header.append('<h5 class="modal-title">' + title + '</h5>');
		}

		if (typeof message == 'string' && !this.isEmptyString(message)) {
			if (message.indexOf('<') !== -1) {
				content.append(message);
			} else {
				content.append('<p class="sdlPopupContent">' + message + '</p>');
			}
		}

		let sdlThis = this;
		
		if (customButtons != null && sdlThis.isArray(customButtons)) {
			let buttons = $('<div class="modal-footer buttonWrapper"></div>');
			inner.append(buttons);
			for (let buttonIndex = 0; buttonIndex < customButtons.length; buttonIndex++) {
				let button = customButtons[buttonIndex];
				let $button = $('<button type="button" class="btn salestoolkit-blue btn-primary sdlPopupButton ' + (button.buttonClass || '') + '">' + button.text + '</button>');
				buttons.append($button);
				if (sdlThis.isFunction(button.action)) {
					$button.on('click', function() {
						button.action();
					});
				} else {
					switch (button.action) {
						case 'close': {
							$button.on('click', function() {
								$('#sdlPopup').remove();
								sdlThis.$modal.modal('show');			
							});
							break;
						}
						
						case 'next': {
							$button.on('click', function() {
								sdlThis.handleSdlQuestion()	
							});
							break;
						}
						default: {
							// do nothing
							break;
						}
					}
				}
			}
		}
			
		$('body').append(popup);
	}
		
	showNationalIdForm() {
		$('#sdlPopup').remove();
		this.$modal.modal('show');
		let sdlThis = this;
		this.$header.text('Please enter your national HCP ID');
		this.fields.forEach(field => {
			const $fieldElement = sdlThis.$modal.find(
				'input[name="' + field.name + '"]'
				+ ', select[name="' + field.name + '"]'
				+ ', textarea[name="' + field.name + '"]'
			);

			if (field.properties.nationalIdField === true || field.properties.nationalIdField === "true") {
				$fieldElement.parents('.atheneum-form-field').removeClass('hidden');
			} else {
				$fieldElement.parents('.atheneum-form-field').addClass('hidden');
			}

			if (field.properties.useVirtualKeyboard === true || field.properties.useVirtualKeyboard === "true") {
				$fieldElement.keyboard();
			}
			
			$fieldElement.attr("readonly", false);

		});
		
		$('.c_form').removeClass('hidden');
		$('#sdlSubmitButton').addClass('hidden');
		$('#sdlRestartButton').addClass('hidden');
		$('#sdlEditButton').addClass('hidden');
		$('#sdlButton').removeClass('hidden');
		this.sdlOptionChosen = 'nationalId';
	}
	
	showUserDetailsForm(){
		$('#sdlPopup').remove();
		this.$modal.modal('show');
		let sdlThis = this;

		this.$header.text('Please enter your details');
		this.fields.forEach(field => {
			const $fieldElement = sdlThis.$modal.find(
				'input[name="' + field.name + '"]'
				+ ', select[name="' + field.name + '"]'
				+ ', textarea[name="' + field.name + '"]'
			);

			if (field.properties.userDetailsField === true || field.properties.userDetailsField === "true") {
				$fieldElement.parents('.atheneum-form-field').removeClass('hidden');
				if(!field.visible && field.visibleInRemoteForm){
					$fieldElement.parents('.atheneum-form-field').show();
				}
			} else {
				$fieldElement.parents('.atheneum-form-field').addClass('hidden');
			}

			if (field.properties.useVirtualKeyboard === true || field.properties.useVirtualKeyboard === "true") {
				$fieldElement.keyboard();
			}
			
			$fieldElement.attr("readonly", false);

		});
		
		$('.c_form').removeClass('hidden');
		$('#sdlSubmitButton').addClass('hidden');
		$('#sdlRestartButton').addClass('hidden');
		$('#sdlEditButton').addClass('hidden');
		$('#sdlButton').removeClass('hidden');
		this.sdlOptionChosen = 'userDetails';

	}
		
	switchSdlForm(){
		if (this.sdlOptionChosen == 'nationalId'){
			this.showUserDetailsForm();
		} else if (this.sdlOptionChosen == 'userDetails'){
			this.showNationalIdForm();
		}
		
		this.hasTriedSdlAlternative = true;
	}
		
	showRegularForm(isFilled){

		if (!isFilled) {
			this.fillFormWithContactMatch(this.currentSdlValues);
		}

		let sdlThis = this;
		$('#sdlPopup').remove();
		this.$modal.modal('show');
		this.$header.text('My details');
		this.fields.forEach(field => {
			const $fieldElement = sdlThis.$modal.find(
				'input[name="' + field.name + '"]'
				+ ', select[name="' + field.name + '"]'
				+ ', textarea[name="' + field.name + '"]'
			);
		
			if (field.requiredInRemoteForm === true || field.requiredInRemoteForm === "true") {
				if (field.name == "to" || field.name == "email"){
					if ($fieldElement.val()!=""){
						$fieldElement.parents('.atheneum-form-field').addClass('hidden');
					} else {
						$fieldElement.parents('.atheneum-form-field').removeClass('hidden');
					}
				} else {
					$fieldElement.parents('.atheneum-form-field').removeClass('hidden');
				}
			} else {
				$fieldElement.parents('.atheneum-form-field').addClass('hidden');
			}
			
			if (isFilled){
				$fieldElement.attr("readonly", true);
			} else {
				$fieldElement.attr("readonly", false);
				if (field.properties.useVirtualKeyboard === true || field.properties.useVirtualKeyboard === "true") {
					$fieldElement.keyboard();
				}
			}
		});
		
		
		$('#sdlSubmitButton').removeClass('hidden');
		$('#sdlButton').addClass('hidden');
		$('#sdlRestartButton').removeClass('hidden');
		
		if (isFilled){
			$('#sdlEditButton').removeClass('hidden');
		} else {
			$('#sdlEditButton').addClass('hidden');
		}
	}
		
		
	stringToBoolean(str) {
	    return str.toLowerCase() === "true";
	}
		
	fillFormWithContactMatch(match) {
		// Check if match is a valid object
		if (typeof match !== 'object' || match === null) {
			console.error("Invalid match object");
			return;
		}
		
		// Iterate through each property in the data object
		$.each(match, function(key, value) {
			// Find the form field with the name matching the key
			const $field = $("[name='" + key + "']");
			
			if ($field.length > 0) {
				$field.val(value);
			}
		});
	}
		
	startSdlQuestionnaire(matches){
		this.sdlMatches = matches;
		this.sdlIndex = 0;
		let sdlThis = this;
		this.sdlFields = this.fields.filter(function(field) {
				return field.properties.sdlQuestion === sdlThis.sdlOptionChosen;
			});
		
		this.askSdlQuestion();
	}
		
	askSdlQuestion() {
		if (this.sdlIndex >= this.sdlFields.length) {
			// If no more questions, exit
			if (this.sdlMatches.length > 1) {
				this.showMoreThanOneMatchesPopup();
			}
			return;
		}
		
		let currentField = this.sdlFields[this.sdlIndex];
		
		let sdlThis = this;
		let fieldWrapper;
		let title;
		let popupButtons;
		if (currentField.properties.askSdlAsButtons == 'true'){
			fieldWrapper = this.createOptionButtons(this.sdlMatches);
			title = this.Atheneum.Translation.get("pleaseChooseOneOption", "Please choose one option");
			popupButtons = [{
				text:  this.Atheneum.Translation.get("close", 'Close'),
				action: 'close'
			}];
		} else { // IAM ADDING THE HTML 
			fieldWrapper = "<div class='atheneum-form-field'>";
			fieldWrapper+= sdlThis.$formElement.find('#'+currentField.name).closest('.atheneum-form-field');
			fieldWrapper+= "</div>";
			title = this.Atheneum.Translation.get("pleaseFillNext", "Please fill the next field");
			popupButtons = [{
				text: this.Atheneum.Translation.get("next", 'Next'),
				action: 'next'
			}];
		}

		this.showSdlPopup(title,fieldWrapper.html(),popupButtons);

	}

	handleSdlQuestion(str){
	
		let currentField = this.sdlFields[this.sdlIndex];
		let inputValue;
		if (str!==null && str!==undefined && str!==""){
			inputValue= str;
		} else {
			// Capture the input value
			inputValue = $('#sdlPopup #'+currentField.id).val();
		}
		
		this.currentSdlValues[currentField.name] = inputValue;
		// Filter the matches based on the input for this field
		this.sdlMatches = this.sdlMatches.filter(function(contact) {
			return contact[currentField.name] === inputValue;
		});
	
		if (this.sdlMatches.length === 0) {
			// If no matches are found, show "No Matches" popup
			this.showNoMatchesPopup();
		} else if (this.sdlMatches.length === 1) {
			// If only one match is found, fill the form with the contact match
			this.fillFormWithContactMatch(this.sdlMatches[0]);
			this.showRegularForm(true);
			
		} else {
			// If more than one match is found, continue to the next question
			this.sdlIndex++;
			this.askSdlQuestion();
		}
	}
	    
	createOptionButtons(dataArray) {
	
		let currentField = this.sdlFields[this.sdlIndex]; 
		let formFieldWrapper = $('<div class="buttonWrapper"></div>');
		
		const uniqueCountries = new Set();
	
		dataArray.forEach(item => {
			if (item[currentField.name]) {
				uniqueCountries.add(item[currentField.name]);
			}
		});
	
		// Create buttons fields for each unique country
		uniqueCountries.forEach(value => {
			const sdlOption = '<button type="button" class="btn salestoolkit-blue btn-primary sdlPopupButtonOption" onclick="parent.sdl.handleSdlQuestion(\''+value+'\')">'+value+'</button>';
			
			formFieldWrapper.append(sdlOption);
		});
		
		return formFieldWrapper;
	}
	    
	
}